import { render, staticRenderFns } from "./Placement.smartlinks.vue?vue&type=template&id=4b82d23d&scoped=true&lang=html&"
import script from "./Placement.smartlinks.vue?vue&type=script&lang=js&"
export * from "./Placement.smartlinks.vue?vue&type=script&lang=js&"
import style0 from "./Placement.smartlinks.vue?vue&type=style&index=0&id=4b82d23d&prod&lang=css&"
import style1 from "./Placement.smartlinks.vue?vue&type=style&index=1&id=4b82d23d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b82d23d",
  null
  
)

export default component.exports